import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './modules/auth';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snackbarText: '',
    snackbarColor: '',
    isLoading: false,

    costList: [],
    costDetails: [],
    memberList: [],
    memberDetails: [],
  },
  mutations: {
    SET_IS_LOADING(state, value) {
      state.isLoading = value;
    },

    SHOW_SNACKBAR(state, value) {
      state.snackbarText = value.text;
      state.snackbarColor = value.color;
    },

    SET_MEMBER_LIST(state, value) {
      state.memberList = value;
    },

    SET_MEMBER_DETAILS(state, value) {
      state.memberDetails = value;
    },

    SET_COST_CRITERIA(state, value) {
      state.costList = value;
    },

    SET_COST_DETAILS(state, value) {
      state.costDetails = value;
    },
  },

  actions: {
    // for members
    getMembers({ commit, rootState }) {
      axios
        .get('/lodge/members', {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then((res) => {
          commit('SET_MEMBER_LIST', res.data.data);
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        });
    },

    addNewMember({ commit, dispatch, rootState }, payload) {
      commit('SET_IS_LOADING', true);
      axios
        .post('/lodge/members', payload, {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then(() => {
          commit('SHOW_SNACKBAR', {
            text: 'New member added successfully',
            color: 'success',
          });
          dispatch('getMembers');
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    getSingleMemberInformation({ commit, rootState }, payload) {
      commit('SET_IS_LOADING', true);
      axios
        .get(`/lodge/members/${payload}`, {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then((res) => {
          commit('SET_MEMBER_DETAILS', res.data.data);
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    addNewInformationForMember({ commit, dispatch, rootState }, payload) {
      commit('SET_IS_LOADING', true);
      axios
        .post('/lodge/credits', payload, {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then(() => {
          commit('SHOW_SNACKBAR', {
            text: 'Information added successfully',
            color: 'success',
          });
          dispatch('getSingleMemberInformation', payload._id);
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    updatedMemberInformation({ commit, rootState }, payload) {
      commit('SET_IS_LOADING', true);
      axios
        .patch(
          `/lodge/credits/${payload._id}`,
          { date: payload.date, through: payload.through, paid_tk: payload.paid_tk, return_tk: payload.return_tk },
          {
            headers: {
              Authorization: 'Bearer ' + rootState.auth.token,
            },
          }
        )
        .then(() => {
          commit('SHOW_SNACKBAR', {
            text: 'Information updated successfully',
            color: 'success',
          });
          location.reload();
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    deleteCreditInfo({ commit, dispatch, rootState }, payload) {
      commit('SET_IS_LOADING', true);
      axios
        .delete(`/lodge/credits/${payload.rowId}`, {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then(() => {
          commit('SHOW_SNACKBAR', {
            text: 'Information deleted successfully',
            color: 'success',
          });
          dispatch('getSingleMemberInformation', payload.criteriaId);
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    // for cost

    getCostCriteria({ commit, rootState }) {
      commit('SET_IS_LOADING', true);
      axios
        .get('/lodge/criterias', {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then((res) => {
          commit('SET_COST_CRITERIA', res.data.data);
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    addNewCriteria({ commit, dispatch, rootState }, payload) {
      commit('SET_IS_LOADING', true);
      axios
        .post('/lodge/criterias', payload, {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then(() => {
          commit('SHOW_SNACKBAR', {
            text: 'Criteria added successfully',
            color: 'success',
          });
          dispatch('getCostCriteria');
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    getSingleCostInformation({ commit, rootState }, payload) {
      commit('SET_IS_LOADING', true);
      axios
        .get(`/lodge/criterias/${payload}`, {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then((res) => {
          commit('SET_COST_DETAILS', res.data.data);
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    addNewInformationForCost({ commit, rootState, dispatch }, payload) {
      commit('SET_IS_LOADING', true);
      axios
        .post('/lodge/debits', payload, {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then(() => {
          commit('SHOW_SNACKBAR', {
            text: 'Information added successfully',
            color: 'success',
          });
          dispatch('getSingleCostInformation', payload._id);
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    updatedCostInformation({ commit, rootState }, payload) {
      commit('SET_IS_LOADING', true);
      axios
        .patch(
          `/lodge/debits/${payload._id}`,
          { date: payload.date, through: payload.through, paid_tk: payload.paid_tk },
          {
            headers: {
              Authorization: 'Bearer ' + rootState.auth.token,
            },
          }
        )
        .then(() => {
          commit('SHOW_SNACKBAR', {
            text: 'Information updated successfully',
            color: 'success',
          });
          location.reload();
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },

    deleteDebitInfo({ commit, dispatch, rootState }, payload) {
      console.log(payload);
      commit('SET_IS_LOADING', true);
      axios
        .delete(`/lodge/debits/${payload.rowId}`, {
          headers: {
            Authorization: 'Bearer ' + rootState.auth.token,
          },
        })
        .then(() => {
          commit('SHOW_SNACKBAR', {
            text: 'Information deleted successfully',
            color: 'success',
          });
          dispatch('getSingleCostInformation', payload.criteriaId);
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit('SHOW_SNACKBAR', { text: `${err.response.data.message}`, color: 'error' });
          } else {
            commit('SHOW_SNACKBAR', {
              text: 'Something went wrong! Please check your internet connection',
              color: 'error',
            });
          }
        })
        .finally(() => commit('SET_IS_LOADING', false));
    },
  },

  modules: {
    auth,
  },

  // custom persistent files
  plugins: [
    createPersistedState({
      paths: ['auth'],
    }),
  ],
});
